import React from 'react';
import { Link } from 'react-router-dom';

import './backdrop.css';

const Backdrop = (props) => {
	return <div className="aspects__backdrop"></div>;
};

export default Backdrop;
